import OpcionReportes from "../../components/organisms/OpcionesReportes";

function Reportes() {
  return <OpcionReportes />;
}
export default Reportes;
